import {Component, Input, OnChanges, OnDestroy, HostListener} from '@angular/core';
import {MiaV3Service} from '../../services/mia-v3.service';

@Component({
  selector: 'app-carrinho-mia',
  templateUrl: './carrinho-mia.component.html',
  styleUrls: ['./carrinho-mia.component.scss']
})
export class CarrinhoMiaComponent implements OnChanges, OnDestroy {
  @Input() contato: any;
  @Input() empresa: any;
  @Input() conversaId: number;
  carrinho: any = null;
  carregando = false;
  abrindo = false;
  expandido = true;
  erro = '';
  abertoNoPdv = false;
  private sequencia = 0;
  private pedidoSincronizado = '';
  private timer: any;
  private destruido = false;
  constructor(private mia: MiaV3Service) {}

  ngOnChanges() {
    this.sequencia++;
    this.carrinho = null;
    this.erro = '';
    this.abertoNoPdv = false;
    this.abrindo = false;
    clearInterval(this.timer);
    if (!this.telefone && !this.conversaId) return;
    void this.atualize();
    this.timer = setInterval(() => { if (!document.hidden && !this.abrindo) void this.atualize(false); }, 10000);
  }

  get telefone(): string {
    // LID não é telefone. Sem identificação, não buscamos o carrinho de outro contato.
    const tel = String(this.contato?.telefone || '');
    if (tel.includes('@')) return '';
    const completo = `${this.contato?.codigoPais || '+55'}${tel}`.replace(/\D/g, '');
    return /^\d{10,15}$/.test(completo) ? completo : '';
  }

  @HostListener('window:focus') aoVoltar() { if (!this.abrindo) void this.atualize(false); }

  async atualize(exibirCarga = true) {
    if ((!this.telefone && !this.conversaId) || this.destruido) return;
    const seq = ++this.sequencia;
    if (exibirCarga) this.carregando = true;
    try {
      const resposta = this.conversaId
        ? {carrinho: await this.mia.obtenhaCarrinhoDaConversa(this.conversaId)}
        : await this.mia.obtenhaCarrinhoDoContato(this.telefone);
      if (seq !== this.sequencia || this.destruido) return;
      this.carrinho = resposta.carrinho;
      this.erro = '';
      if (this.carrinho?.pedido?.fechadoPor === 'ATENDENTE' && this.pedidoSincronizado !== this.carrinho.id) {
        const id = this.carrinho.id;
        await this.mia.atualizePedidoDoCarrinho(id);
        if (seq === this.sequencia && !this.destruido) this.pedidoSincronizado = id;
      }
      // Ausência não prova venda: pode ser limpeza do carrinho.
    } catch (erro: any) {
      if (seq !== this.sequencia || this.destruido) return;
      if (erro?.status === 403) this.carrinho = null;
      if (erro?.status !== 403) this.erro = erro?.error?.erro || 'Não foi possível atualizar o carrinho.';
    } finally {
      if (seq === this.sequencia) this.carregando = false;
    }
  }

  async abrirPdv() {
    if (!this.carrinho?.id || this.abrindo) return;
    const id = this.carrinho.id;
    const seq = ++this.sequencia;
    // Abre no gesto do usuário para não ser bloqueado depois da chamada HTTP.
    const aba = window.open('about:blank', '_blank');
    if (!aba) { this.erro = 'Permita abrir uma nova aba para continuar no PDV.'; return; }
    aba.opener = null;
    this.abrindo = true;
    this.erro = '';
    try {
      const dados = await this.mia.assumaCarrinhoNoPdv(id);
      const params = new URLSearchParams({miaCarrinho: id, tel: dados.telefone, nome: dados.nome || ''});
      aba.location.replace(`${window.location.origin}/admin/pedidos/novo-v3?${params.toString()}`);
      if (seq === this.sequencia && !this.destruido) {
        this.abertoNoPdv = true;
        this.carrinho = {...this.carrinho, status: 'EM_ATENDIMENTO'};
      }
    } catch (erro: any) {
      aba.close();
      if (seq === this.sequencia && !this.destruido) this.erro = erro?.error?.erro || 'Não foi possível abrir o PDV. Tente novamente.';
    } finally {
      if (seq === this.sequencia && !this.destruido) this.abrindo = false;
    }
  }

  get anotacoes(): string[] {
    const a = this.carrinho?.anotacoes;
    if (!a) return [];
    return [a.modoEntrega === 'DELIVERY' ? 'Entrega' : a.modoEntrega === 'RETIRADA' ? 'Retirada' : '',
      a.pagamentoPreferido, a.trocoPreferido === 'SEM' ? 'Sem troco' : a.trocoPreferido ? `Troco para R$ ${Number(a.trocoPreferido).toFixed(2).replace('.', ',')}` : '',
      a.agendamento ? `${a.agendamento.data.split('-').reverse().join('/')} ${a.agendamento.hora || ''}` : '',
      a.cupom ? `Cupom ${a.cupom}` : ''].filter(Boolean);
  }

  ngOnDestroy() { this.destruido = true; this.sequencia++; clearInterval(this.timer); }
}
